const SEATS = {
  2: {
    id: '2',
    label: '2',
    selected: false,
  },
  3: {
    id: '3',
    label: '3',
    selected: false,
  },
  4: {
    id: '4',
    label: '4',
    selected: false,
  },
  5: {
    id: '5',
    label: '5',
    selected: false,
  },
  6: {
    id: '6',
    label: '6',
    selected: false,
  },
  7: {
    id: '7',
    label: '7',
    selected: false,
  },
  8: {
    id: '8',
    label: '8',
    selected: false,
  },
  9: {
    id: '9',
    label: '9',
    selected: false,
  },
};

export { SEATS };
